// Retención ISR 2026 (Anexo 8 RMF / Art. 96 LISR) — honorarios asimilados a salarios
const MONTHLY_TABLE = [
  [0.01, 844.59, 0.0, 0.0192],
  [844.6, 7168.51, 16.22, 0.064],
  [7168.52, 12598.02, 420.95, 0.1088],
  [12598.03, 14644.64, 1011.68, 0.16],
  [14644.65, 17533.64, 1339.14, 0.1792],
  [17533.65, 35362.83, 1856.84, 0.2136],
  [35362.84, 55736.68, 5665.16, 0.2352],
  [55736.69, 106410.5, 10457.09, 0.3],
  [106410.51, 141880.66, 25659.23, 0.32],
  [141880.67, 425641.99, 37009.69, 0.34],
  [425642.0, Infinity, 133488.54, 0.35],
];

const DAYS_PER_MONTH = 30.4;

export function periodDays(start, end) {
  if (!start || !end) return 15;
  const d1 = new Date(start + "T00:00:00");
  const d2 = new Date(end + "T00:00:00");
  return Math.max(Math.round((d2 - d1) / 86400000) + 1, 1);
}

export function calcISR(base, days) {
  if (!base || base <= 0) return 0;
  const factor = days >= 28 && days <= 31 ? 1 : days / DAYS_PER_MONTH;
  for (const [li, ls, cf, pct] of MONTHLY_TABLE) {
    const lo = li * factor;
    const hi = ls * factor;
    if ((base >= lo && base <= hi) || (ls === Infinity && base >= lo)) {
      return Math.round((cf * factor + (base - lo) * pct) * 100) / 100;
    }
  }
  return 0;
}
